import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { PreventDragDropDirective } from '../drag-and-drop/prevent-dragdrop.directive';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';
import { PreventOrphansPipe } from '../pipes/prevent-orphans.pipe';
import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.min-height.rem]': 'resolveMinHeight(minHeight)',
    '[class.no-content-margin]': '!hasContentMargin',
    '[class]': 'variant',
  },
  standalone: true,
  imports: [
    IconColorDirective,
    IconComponent,
    NgStyle,
    PreventDragDropDirective,
    PreventOrphansPipe,
  ],
})
export class EmptyStateComponent {
  public static readonly DEFAULT_MIN_HEIGHT = 22;
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'small',
      'v-centered',
      'with-padding-top',
      'heading-large-x',
      'heading-margin-top-small',
    ],
  ];
  @ComponentVariant(EmptyStateComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public title: string;
  @Input() public titleIcon: IconName;
  @Input() public desc: string;
  @Input() public icon: IconName;
  @Input() public imageUrl: string;
  @Input() public minHeight: boolean | number = false;
  @Input() public hasContentMargin: boolean = true;
  @Input() public fixedImageDimensions?: { width: string; height: string };

  public resolveMinHeight(minHeight: boolean | number): null | number {
    return minHeight === true
      ? EmptyStateComponent.DEFAULT_MIN_HEIGHT
      : typeof minHeight === 'number'
        ? minHeight
        : null;
  }
}
